import apiRequest from './apiClient';

let csrfToken = '';

export const getCsrfToken = () => csrfToken;

export const getSession = async () => {
  const response = await apiRequest('/auth/me.php');
  csrfToken = response.data.csrfToken || '';
  return response.data;
};

export const login = async (identifier, password) => {
  const response = await apiRequest('/auth/login.php', {
    method: 'POST',
    body: JSON.stringify({ identifier, password }),
  });
  csrfToken = response.data.csrfToken || '';
  return response.data.user;
};

export const logout = async () => {
  await apiRequest('/auth/logout.php', {
    method: 'POST',
    headers: { 'X-CSRF-Token': csrfToken },
  });
  csrfToken = '';
};
